/* หน้าสินค้า — สลับรูปใน gallery */
(function () {
  "use strict";
  function init() {
    var main = document.getElementById("sdspMain");
    var thumbs = document.querySelectorAll(".sdsp-thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (!full) return;
        main.src = full;
        thumbs.forEach(function (x) { x.classList.remove("is-on"); });
        t.classList.add("is-on");
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
